import React from 'react'
import classNames from 'classnames'
import { resolvePrefix } from '@toasttab/shared/src/utils/assetUtils'
import { TextIconProps } from './TextIcon.d'

const TextIcon = ({ icon = 'none', text, classes, size }: TextIconProps) => {
  const iconSize = size === 'sm' ? 12 : 24

  const textIconClasses = classNames(
    classes,
    'flex justify-start text-default',
    {
      'text-success': icon === 'metricUpTrend'
    }
  )

  const renderIcon = () => {
    switch (icon) {
      case 'time':
        return resolvePrefix('/svg/icon-time.svg')
      case 'place':
        return resolvePrefix('/svg/icon-place.svg')
      case 'schedule':
        return resolvePrefix('/svg/icon-schedule.svg')
      case 'metricUpTrend':
        return resolvePrefix('/svg/icon-metric-up-trending-green.svg')
      case 'date':
      default:
        return resolvePrefix('/svg/icon-date.svg')
    }
  }

  return (
    <div className={textIconClasses} data-testid='TextIcon'>
      <img
        alt=''
        aria-hidden
        className={size === 'sm' ? 'mr-1' : 'mr-2'}
        data-testid='TextIcon-icon'
        height={iconSize}
        src={renderIcon()}
        width={iconSize}
      />
      {text}
    </div>
  )
}

export default TextIcon
